export const TERM_FILES_PATH = {
  KIBASWAP_TERMS: '/files/15022022KyberSwapTermsofUse.pdf',
  PRIVACY_POLICY: '/files/privacy.pdf',
  KIBA_DAO_TERMS: '/files/dao-tac.pdf',
  // Timestamp of changed date, update this to latest timestamp whenever change any above files. This also used to check on client side for updated to force user to disconnect and re-accept terms.
  VERSION: 1672206443162,
}
